import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {Settings} from '@orga-app/settings/settings.model';
import {select, Store} from '@ngrx/store';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {ActivatedRoute, Router} from '@angular/router';
import * as apiVeranstaltungen from '../../../clients/veranstaltungen';
import {Veranstaltung} from '../../../clients/veranstaltungen';

import * as actionsUi from './veranstaltung-auswaehlen.actions.ui';

import * as fromAppState from '../app-state/app-state.reducer';
import {getAktuelleVeranstaltung} from '../app-state/app-state.reducer';
import * as fromCurrentPage from './veranstaltung-auswaehlen.reducer';
import {GetVeranstaltungBerechtigungAction} from '../../../client-ngrx/veranstaltungen';
import {AktuelleVeranstaltungSetzenAction} from '../app-state/actions/veranstaltung.actions';
import {SafeUrl} from '@angular/platform-browser';
import {getPlatform} from '../app-state/app-state.reducer';
import {VeranstaltungAuswaehlenParameter} from './veranstaltung-auswaehlen.model.ui';

@Component({
    selector: 'app-veranstaltung-auswaehlen',
    templateUrl: './veranstaltung-auswaehlen.page.html',
})
export class VeranstaltungAuswaehlenPage implements OnInit {
    @ViewChild('logoImagePlaceholder', {static: false}) logoImagePlaceholder: ElementRef;
    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    public aktuelleVeranstaltungen$: Observable<Array<apiVeranstaltungen.Veranstaltung>>;
    public aktuelleVeranstaltungId: string;

    public platformState$: Observable<string>;
    public platformState: string;

    private aiName = 'VeranstaltungWaehlenPage';
    public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    public aktuelleVeranstaltungenLaden$: Observable<boolean>;
    public aktuelleVeranstaltungenLadefehler$: Observable<boolean>;

    public fpVeranstaltungenBeendet$: Observable<Array<apiVeranstaltungen.Veranstaltung>>;
    public fpVeranstaltungenBeendetLaden$: Observable<boolean>;
    public fpVeranstaltungenBeendetFehler$: Observable<boolean>;
    private infoKategorien: Array<apiVeranstaltungen.InfoKategorie>;
    private alive = true;
    private windowLocal: Window;

    public param: VeranstaltungAuswaehlenParameter = { funk: false };

    constructor(
        private store: Store<fromCurrentPage.PageState>,
        private storeVeranstaltung: Store<fromAppState.GlobalAppState>,
        private settingsProvider: SettingsProvider,
        public route: ActivatedRoute,
        public router: Router) {

        if (this.router.getCurrentNavigation().extras !== null
            && this.router.getCurrentNavigation().extras.state !== undefined
            && this.router.getCurrentNavigation().extras.state !== null) {
            this.param = <VeranstaltungAuswaehlenParameter> this.router.getCurrentNavigation().extras.state;
        }

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();
    }


    ngOnInit() {
        this.aktuelleVeranstaltung$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltung));
        // Platform from State
        this.platformState$ = this.storeVeranstaltung.pipe(select(getPlatform));

        this.aktuelleVeranstaltungen$ = this.store.pipe(select(fromCurrentPage.getVeranstaltungenAktuelle));
        this.aktuelleVeranstaltungenLaden$ = this.store.pipe(select(fromCurrentPage.getUiZeigeVeranstaltungenAktuelleLaden));
        this.aktuelleVeranstaltungenLadefehler$ = this.store.pipe(select(fromCurrentPage.getUiZeigeVeranstaltungenAktuelleLadefehler));

        this.fpVeranstaltungenBeendet$ = this.store.pipe(select(fromCurrentPage.getFPVeranstaltungenBeendet));
        this.fpVeranstaltungenBeendetLaden$ = this.store.pipe(select(fromCurrentPage.getFPVeranstaltungenBeendetLaden));
        this.fpVeranstaltungenBeendetFehler$ = this.store.pipe(select(fromCurrentPage.getFPVeranstaltungenBeendetFehler));

        this.aktuelleVeranstaltung$.subscribe((aktuelleVeranstaltung) => {
            if (aktuelleVeranstaltung != null) {
                this.aktuelleVeranstaltungId = aktuelleVeranstaltung.veranstaltung_id;
            }
        });

        this.platformState$.subscribe(x => {
            this.platformState = x;
            if (x === 'desktop') {
                this.viewWillEnterPage().then();
            }
        }).unsubscribe();
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        await this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.store.dispatch(new actionsUi.PageLoadDataAction(this.param));
    }

    async pageAktualisieren(event) {
        await this.store.dispatch(new actionsUi.PageLoadDataAction(this.param));
        await event.target.complete();
    }

    async veranstaltungAusweahlen(veranstaltung: Veranstaltung) {
        await this.store.dispatch(new actionsUi.AktuelleVeranstaltungSetzenAction(veranstaltung));
        await this.store.dispatch(new AktuelleVeranstaltungSetzenAction(veranstaltung));
        await this.store.dispatch(new GetVeranstaltungBerechtigungAction(veranstaltung.veranstaltung_id));
        if (this.platformState === 'desktop') {
            this.route.paramMap.subscribe(p => {

                let target = '/checklisten-aufgaben';

                if (p.has('returnTo')) {
                    target = p.get('returnTo');
                }

                // console.debug('navigate to target by Veranstaltung ausgewählt:', target);
                this.router.navigateByUrl(target);
            });
        } else {
            await this.router.navigate(['/veranstaltung', veranstaltung.veranstaltung_id], {
                relativeTo: this.route,
                // queryParams: {returnUrl: this.router.url.split('?')[0]}
            });
            // this.navCtrl.setRoot(VeranstaltungPage);
        }
    }
}
